import { Component, OnInit, Inject, ViewChild, ElementRef, ComponentRef, ViewContainerRef, ComponentFactoryResolver } from '@angular/core';
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DomSanitizer } from "@angular/platform-browser";
import { SharedModule } from '@Shared/shared.module';

@Component({
    selector: 'tranzpay-dialog-component',
    host: { 'class': 'dialog-iframe-content' },
    templateUrl: './tranzpay-dialog.component.html',
    imports: [SharedModule]
})


export class TranzpayDialogComponent implements OnInit{
  @ViewChild('iframe', {static: false}) iframe: ElementRef;
  
  url: any;
  doc;

  constructor(
    private sanitized: DomSanitizer,
    @Inject(MAT_DIALOG_DATA) public data) {
  }
  ngOnInit(): void {
      this.url = this.sanitized.bypassSecurityTrustResourceUrl(this.data.link);
  }

  onLoad(iframe){
      this.doc = iframe.contentDocument || iframe.contentWindow;
  }
}
